import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/overview/main"));


const OverView = () => {
  return (
    <Suspense fallback={<CircularLoader />}>
      <Main />
    </Suspense>
  );
};

export default OverView;



